export default "__VITE_ASSET__zaRFTTpq__";